import { useMemo } from "react";
import { storageUtil } from "./commonFunctions";

const useAccountDomain=()=>{
    const domainNgo=useMemo(()=>storageUtil.get('domain','local'),[]);
    return domainNgo;
}
export default useAccountDomain;